var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#81D61E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 15H15V16.5H9V15ZM9 12H15V13.5H9V12ZM13.5 4.5H7.5C6.675 4.5 6 5.175 6 6V18C6 18.825 6.6675 19.5 7.4925 19.5H16.5C17.325 19.5 18 18.825 18 18V9L13.5 4.5ZM16.5 18H7.5V6H12.75V9.75H16.5V18Z",
    fill: "#0B7340"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentGreen);
export default __webpack_public_path__ + "static/media/document-green.b847eb39465d3d7ef94c1ad5fc9546a8.svg";
export { ForwardRef as ReactComponent };